import type { Destinazione } from '../api/ordini-scrittura.js';
import { t } from '../i18n/lingua.js';

/**
 * La riga della tendina: nome, via e città. Col nome e la città soli BAUER
 * erano quattro righe uguali, e non si capiva quale si stava scegliendo
 * (Antonio, 27 ottobre 2026).
 */
export function voceDestinazione(d: Destinazione): string {
  const dove = [d.address, d.city].filter(Boolean).join(', ');
  return `${d.label}${dove ? ` — ${dove}` : ''}${d.isMain ? ` (${t('sede')})` : ''}`;
}

/** La destinazione scelta, per intero: sotto la tendina, prima di confermare. */
export function SchedaDestinazione({ destinazione: d }: { destinazione: Destinazione }) {
  const localita = [d.postalCode, d.city].filter(Boolean).join(' ');
  return (
    <div className="scheda-destinazione">
      <div className="scheda-destinazione-nome">
        <strong>{d.label}</strong>
        {d.isMain && <span className="badge">{t('sede')}</span>}
      </div>
      {d.address && <div>{d.address}</div>}
      {d.addressExtra && <div>{d.addressExtra}</div>}
      {(localita || d.provinceState || d.country) && (
        <div>
          {localita}
          {d.provinceState && ` (${d.provinceState})`}
          {d.country && `${localita || d.provinceState ? ' — ' : ''}${d.country}`}
        </div>
      )}
      <div className="scheda-destinazione-bc">
        {t('Codice per BC')} <span className="num">{d.bcCode}</span>
        {d.isMain
          ? ` · ${t('in BC è l’indirizzo del cliente')}`
          : d.bc.length > 0 && ` · ${d.bc.map((b) => (b === 'INC' ? t('in BC Inc') : t('in BC SPA'))).join(', ')}`}
      </div>
    </div>
  );
}
